<template>
  <div>
    <CContainer>
      <h1 class="sr-only">{{ $t("sidebar_items.tardy_detentions") }}</h1>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <TardyDetentionsTable></TardyDetentionsTable>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { onMounted, onUnmounted, ref } from "vue"
import { useI18n } from "vue-i18n"
import TardyDetentionsTable from "@/v3components/Datatables/TardyDetentionsTable.vue"
export default {
  name: "TardyDetentions",
  components: { TardyDetentionsTable },
  setup() {
    const { t } = useI18n()
    const previousDocumentTitle = ref("")

    onMounted(() => {
      previousDocumentTitle.value = document.title
      document.title = `${t("sidebar_items.tardy_detentions")} · Securly Pass`
    })

    onUnmounted(() => {
      document.title = previousDocumentTitle.value || "securlypass"
    })

    return {}
  }
}
</script>
